import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

type WorkspacesSkeletonProps = {
  count?: number;
};
function WorkspacesSkeleton({ count = 6 }: WorkspacesSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }

  return (
    <Grid container width='100%' gap={2} padding={2}>
      <Box width={'100%'} display='flex' justifyContent='space-between'>
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='20%'
          height='6rem'
        />
      </Box>
      <Skeleton
        variant='text'
        sx={{ fontSize: '0.7rem' }}
        width='25%'
        height='6rem'
      />
      <Box
        sx={{
          bgcolor: 'white',
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '20px',
          border: '1px solid #EEEEEE',
          width: '100%',
        }}
      >
        {/* Skeleton for Image Uploader */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Skeleton variant='circular' width={150} height={150} />
        </Box>
        {/* Skeleton for Text Fields */}
        <Grid container spacing={2} marginBottom={2}>
          <Grid item xs={6}>
            <Skeleton variant='text' width={'100%'} height={80} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant='text' width={'100%'} height={80} />
          </Grid>
        </Grid>
        {/* Skeleton for Buttons */}
        <Grid container justifyContent='flex-end' spacing={2}>
          <Grid item>
            <Skeleton variant='rectangular' width={150} height={40} />
          </Grid>
          <Grid item>
            <Skeleton variant='rectangular' width={150} height={40} />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

export default WorkspacesSkeleton;
